import { render, staticRenderFns } from "./SubscribeForm.vue?vue&type=template&id=23f9c4d3"
import script from "./SubscribeForm.vue?vue&type=script&lang=js"
export * from "./SubscribeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports